import React, { useEffect } from "react";

export default function FormHubSpotPWC({
  portalId = "46247220",
  formId = "c2309305-89e6-4f03-9d2d-57b3e1645d3d",
  region = "na1",
  event = "form_hubspot_pwc",
  targetId = "hs-form-pwc",
}) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          region,
          event,
          target: `#${targetId}`,
        });
      }
    };

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [portalId, formId, region, event, targetId]);

  return <div id={targetId} />;
}
